import { Text } from '@loadsmart/loadsmart-ui'

import { type TruckType } from 'core/domain/Truck'

import { ALL_EQUIPMENT_TYPES } from 'legacy/constants/equipmentTypes'
import {
  getEquipmentHeight,
  getEquipmentLength,
  getContainerTypeInfo,
} from 'legacy/utils/intermodal'

import { type LoadIntermodal } from '../../domain/LoadIntermodal'
import { type LoadIntermodalContainer } from '../../domain/LoadIntermodalContainer'
import { Item } from './LoadSummary.styles'

type LoadSummaryEquipmentProps = {
  equipmentType: TruckType
  intermodal?: LoadIntermodal
}

function buildIntermodalLabel(container: LoadIntermodalContainer) {
  const length = getEquipmentLength(container.equipmentLength, { short: true })
  const height = getEquipmentHeight(container.equipmentHeight, { short: true })
  const typeInfo = getContainerTypeInfo(container.equipmentType).label
  return `${length}' ${height} ${typeInfo}`
}

export function LoadSummaryEquipment({ equipmentType, intermodal }: LoadSummaryEquipmentProps) {
  // @ts-expect-error ALL_EQUIPMENT_TYPES is not indexed by TruckType. Doing so create more type problems than solves
  const equipment = ALL_EQUIPMENT_TYPES[equipmentType]
  const equipmentLabel = equipment ? equipment.label : equipmentType
  const label = intermodal?.container ? buildIntermodalLabel(intermodal.container) : equipmentLabel

  return (
    <Item>
      <Text as="div" variant="caption-bold" color="color-neutral-dark">
        Equipment
      </Text>
      <Text as="div" variant="body-bold">
        {label}
      </Text>
    </Item>
  )
}
